import React, { createContext, useContext, useMemo, useState } from 'react';

const CompanyContext = createContext(null);

export const CompanyProvider = ({ children }) => {
  const [currentCompanyId, setCurrentCompanyIdState] = useState(() => {
    const stored = localStorage.getItem('last_company_id');
    return stored ? Number(stored) : null;
  });

  const setCurrentCompanyId = (id) => {
    if (id != null) {
      localStorage.setItem('last_company_id', String(id));
    }
    setCurrentCompanyIdState(id != null ? Number(id) : null);
  };

  const value = useMemo(
    () => ({ currentCompanyId, setCurrentCompanyId }),
    [currentCompanyId]
  );

  return (
    <CompanyContext.Provider value={value}>{children}</CompanyContext.Provider>
  );
};

export const useCompanyContext = () => {
  const ctx = useContext(CompanyContext);
  if (!ctx) {
    throw new Error('useCompanyContext must be used within CompanyProvider');
  }
  return ctx;
};

export default CompanyContext;
